import type { SVGProps } from 'react';

export function LocustIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.5 3.6c5.137 0 9.3 4.163 9.3 9.3v1.5l-.015.308A3 3 0 0 1 19.8 17.4h-.461l.945 1.654a.9.9 0 0 1-.334 1.23.897.897 0 0 1-1.226-.334l-1.455-2.546h-3.015l-1.808 2.614a.9.9 0 0 1-1.252.228.9.9 0 0 1-.229-1.252l1.099-1.586H9.27L7.331 20.04a.903.903 0 0 1-1.26.191.903.903 0 0 1-.191-1.26l1.519-2.062-1.613-.615-2.973 3.769a.9.9 0 0 1-1.414-1.114l9-11.4.079-.086a.9.9 0 0 1 .746-.248.89.89 0 0 1 .708.536l.814 1.902L14.28 7.57l.079-.09a.9.9 0 0 1 .75-.27.9.9 0 0 1 .723.54l1.568 3.657h2.408a3 3 0 0 1 1.087.206 7.5 7.5 0 0 0-7.387-6.206h-.6a.9.9 0 0 1-.9-.9c0-.5.4-.9.9-.9h.6zm6 9.9c-.499 0-.9.401-.9.9s.401.9.9.9.9-.401.9-.9-.401-.9-.9-.9M2.831 14.816A2.132 2.132 0 0 1 4.534 11.4h1.035l-2.734 3.416zm6.81-3.416h1.808l.052-.071-.633-1.481-1.227 1.556zm4.043 0h1.751l-.645-1.5z" />
    </svg>
  );
}
